/*
 * CeldaCliente.js — La columna del cliente, igual en todas las tablas (C-024).
 *
 *   Nombre ›  (máx. 2 líneas; el completo en el tooltip; abre la ficha)   ✎ (solo Dueño y Supervisor)
 *   contador · "4 de 7" · 📓 2   (el contador se oculta si la tabla ya está filtrada por esa persona)
 *
 * props:
 *   cliente          { nombre, contador_nombre, comentarios_count, ultima_nota, ultima_nota_autor, ultima_nota_fecha }
 *   onAbrir          abre la ficha
 *   onEditar         abre Editar cliente; sin él no hay lápiz
 *   onNotas          abre la ficha en sus notas
 *   mostrarContador  false cuando la tabla está filtrada por una sola persona
 *   avance           { terminados, total, ayuda } — "4 de 7" en la mensual, "1 de 2" en obligaciones
 *   children         lo que va debajo (etiqueta de revisión, avisos de obligaciones…)
 */
import { NotebookPen, Pencil } from 'lucide-react';
import { BotonIcono } from './Tooltip';
import { fechaCorta } from './estados';

const primerNombre = (nombre) => (nombre || '').trim().split(/\s+/)[0];

export const textoUltimaNota = (cliente) => {
  if (!cliente.ultima_nota) return '';
  const cuando = cliente.ultima_nota_fecha ? fechaCorta(cliente.ultima_nota_fecha) : '';
  const quien = primerNombre(cliente.ultima_nota_autor);
  const encabezado = [cuando, quien].filter(Boolean).join(', ');
  return `${encabezado ? `${encabezado}: ` : ''}${cliente.ultima_nota}`;
};

export default function CeldaCliente({ cliente, onAbrir, onEditar, onNotas, mostrarContador = true, avance, children }) {
  const notas = Number(cliente.comentarios_count) || 0;
  const ultima = textoUltimaNota(cliente);
  const textoNotas = `${notas} ${notas === 1 ? 'nota' : 'notas'}${ultima ? `. Última: ${ultima}` : ''}`;
  return (
    <div className="cli-celda">
      <div className="cli-fila1">
        <button
          type="button"
          className="cliente-nombre-btn"
          data-tooltip={`${cliente.nombre} · Abrir ficha del cliente`}
          onClick={onAbrir}
        >
          <span className="cli-nombre-texto">{cliente.nombre}</span>
        </button>
        {onEditar && (
          <BotonIcono className="cli-editar" etiqueta={`Editar ${cliente.nombre}`} onClick={onEditar}>
            <Pencil size={14} aria-hidden="true" />
          </BotonIcono>
        )}
      </div>
      <div className="cli-fila2">
        {mostrarContador && cliente.contador_nombre && <span className="cli-contador">{cliente.contador_nombre}</span>}
        {avance && (
          <span className="cli-avance" tabIndex={0} data-tooltip={avance.ayuda} aria-label={avance.ayuda}>
            <b>{avance.terminados}</b> de {avance.total}
          </span>
        )}
        {notas > 0 && (
          <BotonIcono className="cli-notas" etiqueta={textoNotas} onClick={onNotas || onAbrir}>
            <NotebookPen size={14} aria-hidden="true" /> <b>{notas}</b>
          </BotonIcono>
        )}
      </div>
      {children}
    </div>
  );
}
